import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { T2CardComponent } from './components/t2-card/t2-card.component';
import { T2SidebarComponent } from './components/t2-sidebar/t2-sidebar.component';
import { T2MenuComponent } from './components/t2-menu/t2-menu.component';
import { T2HeaderMainComponent } from './components/t2-header-main/t2-header-main.component';
import { T2ContentMainComponent } from './components/t2-content-main/t2-content-main.component';
import { T2FooterMainComponent } from './components/t2-footer-main/t2-footer-main.component';
import { T2TemplateBasicComponent } from './components/t2-template-basic/t2-template-basic.component';
import { RouterModule } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg';
import { T2ThemeService } from './t2-theme.service';
import { AuthenticationService } from '../pages/login/authentication.service';
import { T2LoadingComponent } from './components/t2-loading/t2-loading.component';
import { ProfilesModule } from '../pages/profiles/profiles.module';
import { ComplianceService } from '../core/services/compliance.service';
import { DocumentsVerifyModule } from '../pages/documents-verify/documents-verify.module';
import { ChangePasswordModule } from '../pages/change-password/change-password.module';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from 'app/directives/directives.module';
import { DebugerAppModule } from 'app/pages/A2-utils/debuger-app/debuger-app.module';
import { T2BadgeProvidersComponent } from './components/t2-badge-providers/t2-badge-providers.component';
import { T2HelpComponent } from './components/t2-help/t2-help.component';


@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        InlineSVGModule,
        ChangePasswordModule,
        ProfilesModule,
        DocumentsVerifyModule,
        FormsModule,
        DirectivesModule,
        DebugerAppModule
    ],
  declarations: [
      T2CardComponent,
      T2SidebarComponent,
      T2MenuComponent,
      T2HeaderMainComponent,
      T2ContentMainComponent,
      T2FooterMainComponent,
      T2TemplateBasicComponent,
      T2LoadingComponent,
      T2BadgeProvidersComponent,
      T2HelpComponent
      ],
  exports: [
      T2CardComponent,
      T2TemplateBasicComponent,
      T2LoadingComponent
  ],
  providers: [
      T2ThemeService,
      AuthenticationService,
      ComplianceService
  ],
  bootstrap: []
})
export class Trip2ThemeModule { }



// WEBPACK FOOTER //
// ./src/app/trip2-theme/trip2-theme.module.ts